/**
 * LUSH Auto-Redirect Variants
 * Automatically redirects variant products to master products with consolidated view
 */

class AutoRedirectVariants {
  constructor() {
    this.init();
  }

  init() {
    // Only run on product pages
    if (window.location.pathname.includes('/products/')) {
      this.checkAndRedirect();
    }
  }

  checkAndRedirect() {
    // Get current product data from the page
    const productData = this.getProductData();
    
    if (!productData) {
      console.log('No product data found');
      return;
    }

    // Check if this is a variant product (not master)
    if (this.isVariantProduct(productData)) {
      const masterProduct = this.findMasterProduct(productData);
      
      // Only redirect if master product is available
      if (masterProduct && masterProduct.available !== false) {
        this.redirectToMaster(masterProduct);
      } else {
        console.log('Master product is not available, staying on variant page');
      }
    }
  }

  getProductData() {
    // Try to get product data from various sources
    let productData = null;

    // Method 1: Check for product JSON in page
    const productJson = document.querySelector('script[type="application/json"][id*="ProductJson"]');
    if (productJson) {
      try {
        productData = JSON.parse(productJson.textContent);
      } catch (e) {
        console.log('Could not parse product JSON');
      }
    }

    // Method 2: Check for metafields in page
    if (!productData) {
      const metafields = this.getMetafieldsFromPage();
      if (metafields) {
        productData = {
          handle: this.getProductHandleFromUrl(),
          metafields: metafields
        };
      }
    }

    return productData;
  }

  getMetafieldsFromPage() {
    // Look for metafields in the page HTML
    const variantGroup = document.querySelector('[data-variant-group]');
    const isMaster = document.querySelector('[data-is-master]');
    
    if (variantGroup || isMaster) {
      return {
        'specs.variant_group': variantGroup ? variantGroup.getAttribute('data-variant-group') : null,
        'specs.is_master_variant': isMaster ? isMaster.getAttribute('data-is-master') : null
      };
    }

    return null;
  }

  getProductHandleFromUrl() {
    const path = window.location.pathname;
    const match = path.match(/\/products\/([^\/\?]+)/);
    return match ? match[1] : null;
  }

  isVariantProduct(productData) {
    // Check if this product is NOT a master variant
    if (productData.metafields && productData.metafields['specs.is_master_variant']) {
      return productData.metafields['specs.is_master_variant'] !== 'true';
    }

    // If no metafields, check if it's part of a variant group but not the master
    if (productData.metafields && productData.metafields['specs.variant_group']) {
      const variantGroup = productData.metafields['specs.variant_group'];
      const groupProducts = variantGroup.split(', ');
      
      // If this product is in a group but not the first one, it's likely a variant
      if (groupProducts.length > 1 && groupProducts[0] !== productData.handle) {
        return true;
      }
    }

    return false;
  }

  findMasterProduct(productData) {
    if (!productData.metafields || !productData.metafields['specs.variant_group']) {
      return null;
    }

    const variantGroup = productData.metafields['specs.variant_group'];
    const groupProducts = variantGroup.split(', ');

    // Look for the master product in the group
    for (const handle of groupProducts) {
      if (handle && handle !== productData.handle) {
        return {
          handle: handle,
          url: `/products/${handle}?view=consolidated`,
          available: true // We'll check availability in checkAndRedirect
        };
      }
    }

    return null;
  }

  redirectToMaster(masterProduct) {
    console.log('Redirecting to master product:', masterProduct.url);
    
    // Add a small delay to show the redirect is happening
    setTimeout(() => {
      window.location.href = masterProduct.url;
    }, 100);
  }
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', function() {
  // Only run if we're not already on a consolidated view
  // Temporarily disabled to allow direct access to variant products
  // if (!window.location.search.includes('view=consolidated')) {
  //   window.autoRedirectVariants = new AutoRedirectVariants();
  // }
});

// Export for use in other scripts
if (typeof module !== 'undefined' && module.exports) {
  module.exports = AutoRedirectVariants;
} 